import { Component, OnInit } from '@angular/core';
import { FileUploadComponent } from 'src/app/file-upload/file-upload.component';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { AngularFireDatabase } from 'angularfire2/database';
import * as firebase from 'firebase';

@Component({
  selector: 'app-declaracao-cqt',
  templateUrl: './declaracao-cqt.component.html',
  styleUrls: ['./declaracao-cqt.component.scss']
})
export class DeclaracaoCqtComponent implements OnInit {

  name: any;
  email: any;
  identidade: any;
  orgao: any;
  nascimento: any;
  mae: any;
  pai: any;
  comprovantePagamento: any;
  comprovanteIdentidade: any;
  constructor(public dialog: MatDialog,  private toastr: ToastrService, private db: AngularFireDatabase) { }

  ngOnInit() {
  }

  upload(id) {
    // console.log('aa', x);
    const dialogRef = this.dialog.open(FileUploadComponent, {
      width: '800px',
      // height: '75%',
      maxHeight: '80vh',
      data: {}
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (!id) {
          this.comprovantePagamento = res;
        } else {
          this.comprovanteIdentidade = res;
        }
        console.log(res);
      }
    });
  }


  isOk(d) {
    if (!d) { return false; }
    const x = d.toString();
    if (!x || x.trim().length === 0 || x.trim() === '') {
      return false;
    }
    return true;
  }


  send() {
    if (!this.isOk(this.name)) {
      this.toastr.error('Informe o seu nome.');
      return;
    }
    if (!this.isOk(this.email)) {
      this.toastr.error('Informe o seu email.');
      return;
    }
    if (!this.isOk(this.identidade)) {
      this.toastr.error('Informe a sua identidade.');
      return;
    }
    if (!this.isOk(this.orgao)) {
      this.toastr.error('Informe o órgão expedidor da sua identidade.');
      return;
    }
    if (!this.isOk(this.nascimento) || this.nascimento.toString().length !== 8) {
      this.toastr.error('Informe a sua data de nascimento.');
      return;
    }
    if (!this.isOk(this.mae)) {
      this.toastr.error('Informe o nome da sua mãe.');
      return;
    }
    if (!this.comprovantePagamento) {
      this.toastr.error('Você deve enviar o comprovante de pagamento.');
      return;
    }
    if (!this.comprovanteIdentidade) {
      this.toastr.error('Você deve enviar o comprovante da sua identidade.');
      return;
    }

    const json = {
      name: this.name,
      email: this.email,
      identidade: this.identidade,
      orgao: this.orgao,
      nascimento: this.nascimento,
      mae: this.mae,
      pai: this.pai || '',
      comprovanteIdentidade: this.comprovanteIdentidade,
      comprovantePagamento: this.comprovantePagamento,
      created: firebase.database.ServerValue.TIMESTAMP,
    };

    console.log('enviando', json);
    this.db.database.ref(`peddingDeclarations/imobiliaria-cqt`).push(json).then((x) => {
      if (x) {
        this.toastr.success('Declaração solicitada com sucesso.\nEm breve você receberá um email');
        console.log('foi');
        window.location.href = 'http://cursoscqt.com.br';
      } else {
        this.toastr.error('Ocorreu um erro, tente novamente');
      }
    });
  }
}
